(() => {
  'use strict';
  const selector = 'form[data-natura-crm-secondary]';
  const initialized = new WeakSet();
  const widgets = new WeakMap();
  let captchaPromise;
  function syncAvailability(form) {
    if (form.dataset.naturaCrmSecondary !== 'availability') return;
    const scope = form.closest('.product-details-wrapper') || document;
    const select = scope.querySelector('form[action*="/cart/add"] select[name="id"]');
    const option = select?.selectedOptions[0];
    if (!option) return;
    form.hidden = !option.disabled;
    const body = form.elements.namedItem('contact[body]');
    if (body) {
      const product = scope.querySelector('h1')?.textContent.trim() || document.title;
      body.value = 'Demande de disponibilité : ' + product + ' — ' + option.textContent.trim() + '. Variante : ' + option.value;
    }
  }
  function captchaApi() {
    if (window.grecaptcha && typeof window.grecaptcha.render === 'function') return Promise.resolve(window.grecaptcha);
    if (captchaPromise) return captchaPromise;
    captchaPromise = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('captcha unavailable')), 15000);
      window.naturaSecondaryCaptchaReady = () => { clearTimeout(timer); resolve(window.grecaptcha); };
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?onload=naturaSecondaryCaptchaReady&render=explicit';
      script.async = true; script.defer = true;
      script.onerror = () => { clearTimeout(timer); reject(new Error('captcha unavailable')); };
      document.head.appendChild(script);
    });
    return captchaPromise;
  }
  function error(form, message) {
    const box = form.querySelector('[data-secondary-error]');
    box.textContent = message;
    box.hidden = false;
    box.scrollIntoView({block:'center'});
  }
  function renderCaptcha(form) {
    const holder = form.querySelector('[data-secondary-captcha]');
    if (!holder || holder.getBoundingClientRect().width === 0 || widgets.has(form)) return;
    widgets.set(form, null);
    captchaApi().then(api => {
      if (!form.isConnected) return;
      const widget = api.render(holder, {
        sitekey: '6LdK9P8tAAAAAL3U4oNKhCJY1QNKrPOIi0tB8fav',
        size: holder.getBoundingClientRect().width < 310 ? 'compact' : 'normal',
        callback: () => { form.querySelector('[data-secondary-error]').hidden = true; },
        'error-callback': () => error(form, 'Le contrôle antirobot ne répond pas. Rechargez la page ou écrivez à contact@natura-beziers.com.')
      });
      widgets.set(form, widget);
      const button = form.querySelector('[type="submit"]');
      if (button && form.dataset.naturaCrmSecondary === 'availability') button.disabled = false;
    }).catch(() => error(form, 'Le contrôle antirobot ne s’est pas chargé. Rechargez la page ou écrivez à contact@natura-beziers.com.'));
  }
  function initialize(form) {
    if (!form.elements.namedItem('00NMI00000TMweF')) return;
    if (initialized.has(form)) { renderCaptcha(form); return; }
    initialized.add(form);
    const field = name => form.elements.namedItem(name);
    const ref = field('00NMI00000TMweF');
    ref.value = 'NATURA-' + crypto.randomUUID();
    let submitted = false;
    const timer = setInterval(() => {
      if (!form.isConnected) { clearInterval(timer); return; }
      const response = field('g-recaptcha-response');
      if (!response || !response.value.trim()) {
        const settings = JSON.parse(field('captcha_settings').value);
        settings.ts = Date.now();
        field('captcha_settings').value = JSON.stringify(settings);
      }
    }, 500);
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) renderCaptcha(form);
    });
    observer.observe(form);
    form.addEventListener('focusin', () => renderCaptcha(form));
    form.addEventListener('submit', event => {
      if (event.defaultPrevented) return;
      syncAvailability(form);
      if (form.hidden) { event.preventDefault(); return; }
      const response = field('g-recaptcha-response');
      if (submitted || !response || !response.value.trim()) {
        event.preventDefault();
        if (!submitted) error(form, 'Validez la case « Je ne suis pas un robot » avant l’envoi.');
        return;
      }
      const read = name => (field(name)?.value || '').trim();
      const contactName = read('contact[name]');
      const email = read('contact[email]');
      if (!email) { event.preventDefault(); error(form, 'Renseignez votre adresse e-mail.'); return; }
      const parts = [];
      for (const input of form.querySelectorAll('[name^="contact["]')) {
        if (input.name === 'contact[email]' || input.name === 'contact[name]' || input.name === 'contact[phone]') continue;
        const value = input.value.trim();
        if (value) parts.push(input.name.slice(8,-1) + ' : ' + value);
      }
      parts.push('Page : ' + location.origin + location.pathname + location.search);
      if (form.dataset.naturaCrmSecondary === 'availability') {
        const variant = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (variant?.value) parts.push('Variante produit : ' + variant.value);
      }
      const description = parts.join('\n\n');
      if (description.length > 32000) {
        event.preventDefault();
        error(form, 'Votre composition dépasse la capacité du formulaire. Conservez son lien avec « Conserver mon projet », puis transmettez-le à contact@natura-beziers.com avec vos coordonnées.');
        return;
      }
      field('last_name').value = contactName || 'Non renseigné';
      field('email').value = email;
      field('phone').value = read('contact[phone]');
      field('description').value = description;
      const returnUrl = form.dataset.naturaCrmSecondary === 'moss' ? new URL('/pages/configurateur-mur-vegetal', document.baseURI) : new URL(location.href);
      returnUrl.hash = 'natura-demande-envoyee';
      field('retURL').value = returnUrl.href;
      submitted = true;
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      form.querySelector('[data-secondary-error]').hidden = true;
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      submitted = false;
      const widget = widgets.get(form);
      if (widget !== null && widget !== undefined && window.grecaptcha) window.grecaptcha.reset(widget);
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = false;
    });
    renderCaptcha(form);
  }
  function start() {
    const scan = () => document.querySelectorAll(selector).forEach(form => {
      if (location.hash === '#natura-demande-envoyee') form.hidden = true;
      else { syncAvailability(form); initialize(form); }
    });
    if (location.hash === '#natura-demande-envoyee') {
      const form = document.querySelector(selector);
      const target = document.getElementById('request-section') || document.querySelector('main') || document.body;
      const notice = document.createElement('div');
      notice.id = 'contact-success'; notice.setAttribute('role','status'); notice.tabIndex = -1;
      notice.textContent = 'Merci, votre demande a été transmise à NATURA. Notre équipe reviendra vers vous.';
      notice.style.cssText = 'background:#f4f6ef;color:#2f3326;border-left:4px solid #8dab4b;padding:20px;margin:20px 0';
      target.hidden = false;
      target.prepend(notice);
      if (form) form.hidden = true;
      notice.focus();
    }
    scan();
    document.addEventListener('change', scan);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; scan(); });
    }).observe(document.body, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

